import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { NotificationService } from 'src/@core/services/notification.service';
import { AgentEvalsService } from '../agent-evals.service';
import { AgentEvalTest } from '../agent-evals.types';

export interface GenerateTestsDialogData {
  entityId: string;
  projectId: string;
}

@Component({
  selector: 'hour4u-admin-generate-agent-eval-tests-dialog',
  templateUrl: './generate-tests-dialog.component.html',
  styleUrls: ['./generate-tests-dialog.component.scss'],
})
export class GenerateAgentEvalTestsDialogComponent implements OnInit {
  loading = false;
  saving = false;
  drafts: AgentEvalTest[] = [];
  selected: { [index: number]: boolean } = {};

  constructor(
    private dialogRef: MatDialogRef<GenerateAgentEvalTestsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GenerateTestsDialogData,
    private agentEvalsService: AgentEvalsService,
    private notify: NotificationService
  ) {}

  ngOnInit(): void {
    this.generate();
  }

  generate(): void {
    this.loading = true;
    this.agentEvalsService.generateTests(this.data.entityId, this.data.projectId, false).subscribe(
      (drafts) => {
        this.drafts = drafts || [];
        this.selected = {};
        this.drafts.forEach((_, i) => (this.selected[i] = true));
        this.loading = false;
        if (!this.drafts.length) {
          this.notify.showMessage('No tests generated — check project final prompt', 4000);
        }
      },
      (err) => {
        this.loading = false;
        const msg = (err && err.error && err.error.message) || 'Generate failed';
        this.notify.showMessage(msg, 4000);
      }
    );
  }

  selectedCount(): number {
    return Object.keys(this.selected).filter((k) => this.selected[+k]).length;
  }

  addSelected(): void {
    const chosen = this.drafts.filter((_, i) => this.selected[i]);
    if (!chosen.length) {
      this.notify.showMessage('Select at least one test', 3000);
      return;
    }
    this.saving = true;
    let remaining = chosen.length;
    const saved: AgentEvalTest[] = [];
    chosen.forEach((draft) => {
      this.agentEvalsService
        .createTest({
          entity_id: this.data.entityId,
          project_id: this.data.projectId,
          name: draft.name,
          area: draft.area,
          critical: draft.critical,
          description: draft.description,
          success_criteria: draft.success_criteria,
          source: 'generated',
        })
        .subscribe(
          (test) => {
            saved.push(test);
            remaining -= 1;
            if (remaining <= 0) {
              this.saving = false;
              this.dialogRef.close(saved);
            }
          },
          (err) => {
            remaining -= 1;
            if (remaining <= 0) {
              this.saving = false;
              if (saved.length) {
                this.dialogRef.close(saved);
              } else {
                const msg = (err && err.error && err.error.message) || 'Failed to save tests';
                this.notify.showMessage(msg, 4000);
              }
            }
          }
        );
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
